import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import plusIcon from 'assets/images/icons/plus.svg';
import ListViewCommittee from './ListViewCommittee';
import comptroller from 'assets/images/comptroller_white.svg';
import { useNavigate } from 'react-router-dom';
// import { TabsItemFour as TabsItem } from "pages/globals/global";
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { useGetCommitteeListMutation } from 'store/features/comptroller/comptrollerApi';

function Committee() {
	const theme = useTheme();
	const navigate = useNavigate();
	// const [searchParams] = useSearchParams();

	const [committeeTable, setCommitteeTable] = useState([]);
	const [activeCreateButton, setActiveCreateButton] = useState(true);
	// const [selectedTab, setSelectedTab] = useState(() => {
	//   const activeTab = searchParams.get("tab");

	//   if (activeTab) {
	//     const index = TabsItem?.findIndex((item) => item?.label === activeTab);

	//     if (index > -1) return index;
	//   }

	//   return 0;
	// });

	const { profileData } = useSelector((state) => state?.profile);

	const [GetCommitteeList, { data: committeeList, isLoading }] = useGetCommitteeListMutation();

	// const selectTabHandler = (event, newValue) => {
	//   setSelectedTab(newValue);

	//   const tabName = TabsItem?.[newValue]?.label;

	//   navigate(`/static/committee?tab=${tabName}`, { replace: true });
	// };

	// useEffect(() => {
	//   setActiveCreateButton(isLoading);
	// }, [isLoading]);

	// useEffect(() => {
	//   if (accessControlTable) {
	//     let temp = [],
	//       temp1 = [],
	//       temp2 = [];
	//     accessControlTable?.lynMapPeopleProcessList?.map((value, index) => {
	//       temp[value?.codeTask] = value;
	//       temp1[value?.codeProcess] = value;
	//       if (temp2[value?.value] !== undefined || temp2[value?.value] !== null) {
	//         temp2[value?.value] = value;
	//       }
	//       return value;
	//     });
	//     setExistingTaskListMap(temp1);
	//     setExistingEmployeeListMap(temp2);
	//   }
	// }, [accessControlTable]);

	// useEffect(() => {
	//   if (profileData) {
	//     GetActiveProcessList({
	//       companyCode: profileData?.creatorOrganizationId,
	//     });
	//     GetEmployeeListByCompanyCode({
	//       parentCode: profileData?.creatorOrganizationId,
	//     });
	//   }
	//   //eslint-disable-next-line
	// }, [profileData]);

	// useEffect(() => {
	//   if (employeeList) {
	//     let temp = [],
	//       temp1 = [];
	//     employeeList?.map((value, index) => {
	//       temp.push({
	//         label: value?.entityFullName,
	//         value: value?.entityCode,
	//       });
	//       temp1[value?.entityCode] = value;
	//       return value;
	//     });
	//     setEmployeeListOptions(temp);
	//     setUserListMap(temp1);
	//   }
	// }, [employeeList]);

	// useEffect(() => {
	//   if (activeProcessList) {
	//     let temp = [],
	//       temp1 = [];
	//     activeProcessList?.lynProcess?.map((value, index) => {
	//       temp.push({
	//         label: value?.name,
	//         value: value?.processCode,
	//         version: value?.processVersion,
	//       });
	//       temp1[value?.processCode] = value;
	//       return value;
	//     });
	//     setSolutionOptions(temp);
	//   }
	// }, [activeProcessList]);

	// useEffect(() => {
	//   if (profileData?.creatorOrganizationId) {
	//     GetAccessControlList({
	//       codeCompany: profileData?.creatorOrganizationId,
	//     });
	//   }
	//   //eslint-disable-next-line
	// }, [profileData]);

	useEffect(() => {
		if (committeeList) {
			setCommitteeTable(committeeList?.result);

			setActiveCreateButton(false);
		}
	}, [committeeList]);

	useEffect(() => {
		if (profileData) {
			GetCommitteeList({
				companyCode: profileData?.creatorOrganizationId,
			});
		}
		//eslint-disable-next-line
	}, [profileData?.creatorOrganizationId]);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<Box
					sx={{
						width: '100%',
						borderRadius: 1,
					}}
				>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						sx={{
							bgcolor: '#214689',
							px: '15px',
							py: '12px',
							color: 'common.white',
						}}
						style={{ borderRadius: '6px 6px 0 0' }}
					>
						<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
							<img alt="comptroller" src={comptroller} width="18px" height="18px" />
							<Typography variant="h4">Committees</Typography>
						</Stack>

						<Button
							type="primary"
							disabled={activeCreateButton}
							onClick={() => navigate('/static/committee/create', { state: {} })}
							sx={{
								color: 'white',
								display: 'flex',
								fontWeight: 450,
								boxShadow: 'none',
								padding: '3px 15px',
								alignItems: 'center',
								transition: 'all 0.3s',
								backgroundColor: activeCreateButton ? 'gray' : theme.palette.lynTheme.success,
								border: `1px solid ${activeCreateButton ? 'gray' : theme.palette.lynTheme.success}`,
								borderColor: '#ffff',

								'&:hover': {
									backgroundColor: activeCreateButton ? 'gray' : '#207f3b',

									transform: 'scale(0.9)',
								},
							}}
						>
							<img src={plusIcon} alt="add" width="12" height="12" style={{ marginRight: '8px' }} />
							Create
						</Button>
					</Stack>

					{/* <Box sx={{ width: "100%", backgroundColor: "white" }} style={{ borderRadius: "0px 0px 6px 6px" }}>
            <Tabs
              value={selectedTab}
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#214689",
                  borderRadius: "0px 0px 0px 6px",
                },
                "& .Mui-selected": {
                  color: "#214689",
                },

                "& .MuiTab-root": {
                  backgroundColor: "white",
                  opacity: 1,
                },
              }}
              scrollButtons
              textColor="inherit"
              allowScrollButtonsMobile
              onChange={selectTabHandler}
              aria-label="basic tabs example"
              variant={matchDownSM ? "scrollable" : "standard"}
            >
              <Tab
                key="Active"
                label="Active"
                iconPosition="start"
                icon={<LynIcon folder="icons" fileName="active" format="svg" sx={{ marginRight: "16px" }} />}
                sx={{
                  // padding: "5px 50px",
                  width: "176px",
                }}
                {...a11yProps(0)}
              />
              <Tab
                key="W-I-P"
                label="W-I-P"
                iconPosition="start"
                icon={<LynIcon folder="icons" fileName="inactive" format="svg" sx={{ marginRight: "16px" }} />}
                sx={{
                  // padding: "5px 50px",
                  width: "176px",
                }}
                {...a11yProps(1)}
              />
              <Tab
                key="Inactive"
                label="Inactive"
                iconPosition="start"
                icon={<LynIcon folder="icons" fileName="deactivated" format="svg" sx={{ marginRight: "16px" }} />}
                sx={{
                  // padding: "5px 50px",
                  width: "176px",
                }}
                {...a11yProps(2)}
              />
              <Tab
                key="All"
                label="All"
                iconPosition="start"
                icon={<LynIcon folder="icons" fileName="all" format="svg" sx={{ marginRight: "16px" }} />}
                sx={{
                  // padding: "5px 50px",
                  width: "176px",
                }}
                {...a11yProps(3)}
              />
            </Tabs>
          </Box> */}
				</Box>

				<ListViewCommittee userPreferenceTable={committeeTable} isLoading={isLoading} />
			</Grid>
		</Grid>
	);
}

export default Committee;
